<div aria-label="taskTableHeader" role="tabpanel" style="pointer-events: auto;">
  <div style="position: absolute; margin-top: 12px; margin-left: 225px;">
    <span *ngIf="loading" class="spinner-border spinner mr-1 mt-1"></span>
  </div>

    <app-configurable-header 
    [headingText]="'My-maintenance.taskTableView' | translate" 
    [variant]="'none'" 
    [tooltipTwo]="'Edit'"
    [tooltipThree]="'Close'"
    (actionThree)="closeSmartTable()"
    [iconThree]="'cross'"
    [iconTwo]="'pencil'"
    [iconTwoDropdown]="false"
    (actionTwo)="showToolkit()"
    [checkboxlabel1]="'My-maintenance.input.assigntome' | translate " 
    [checkboxChecked]="checkboxChecked"
    (checkboxClick)="assignedToChanged($event)"
    [isTaskViewerHeader]="true"
    > </app-configurable-header>
    
  <div class="row" role="table">
    <div class="col-12">
      <div style="background-color: Gray 10">
        <div style="display: flex; flex-direction: row">
          <div class="myTask" style="overflow: hidden; flex-grow: 1">
            
            <mat-tab-group (selectedTabChange)="tabChanged($event)">
              <mat-tab label="{{'My-maintenance.tab.open' | translate }}" > 
                <div class="tab-content">
                <ag-grid-angular
                  #agOpenGrid
                  style="width: 100%;height:229px !important;"
                  class="ag-theme-balham mtTableHeight"
                  [pagination]="true"
                  [paginationPageSize]="100"
                  [gridOptions]="gridOptions"
                  [rowSelection]="rowSelection"
                  [components]="components"
                  (gridReady)="onGridReadyOpen($event)"
                  (selectionChanged)="onSelectionChangedOpen($event)"
                  [rowData]="rowData"
                  [columnDefs]="columnDefsOpen">
              
                </ag-grid-angular>
              </div>
                    </mat-tab>
               
              <mat-tab label="{{'My-maintenance.tab.completed' | translate}}">
                <ag-grid-angular
                  #agClosedGrid
                  style="width: 100%;height:229px !important;"
                  class="ag-theme-balham mtTableHeight"
                  [pagination]="true"
                  [paginationPageSize]="100"
                  [gridOptions]="gridOptions"
                  [rowSelection]="rowSelection"
                  [components]="components"
                  (gridReady)="onGridReadyClosed($event)"
                  (selectionChanged)="onSelectionChangedClosed($event)"
                  [rowData]="rowDataClosed"
                  [columnDefs]="columnDefsClosed"
                >
                </ag-grid-angular>
                 
              </mat-tab>

              <!-- jcc 7/15/25 Optimized functionality is not fully developed. hide until it becomes a priority, if ever. also moved to last so open and closed tab index don't change if decide to include this tab again.
                <mat-tab label="{{'My-maintenance.tab.optimized' | translate }}">
                <div class="tab-content">
                <ag-grid-angular
                #agOptGrid
                style="width: 100%;height:229px !important;"
                class="ag-theme-balham mtTableHeight"
                [pagination]="true"
                [paginationPageSize]="10"
                [gridOptions]="gridOptions"
                [rowSelection]="rowSelection"
                [components]="components"
                (gridReady)="onGridReadyOpt($event)"
                (selectionChanged)="onSelectionChangedOpt($event)"
                [rowData]="rowData"
                [columnDefs]="columnDefsOpt"
              >
              </ag-grid-angular></div>
              </mat-tab> -->
             
            </mat-tab-group>
           
          </div>

          <div *ngIf="activityToolKitListGroup.length && showtools" style="background-color: #fff; padding: 2rem; width: 20%">
            <div class="card">
              <div class="card-header">
                {{ "My-maintenance.tab.resourcelist" | translate }}
              </div>
              <div class="card-body" style="max-height: 250px; overflow-y: auto">
                <ul class="list-group">
                  <li data-forTab="yes"
                    *ngFor="let tool of activityToolKitListGroup; let i = index"
                    class="list-group-item d-flex justify-content-between align-items-center"
                  >
                    {{ tool.toolName }}
                    <h4>
                      <span class="badge badge-pill"> {{ tool.count }}</span>
                    </h4>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>